import { combineReducers } from 'redux';

import dashboard from './dashboard';
import details from './details';
import modal from './modal';
import select from './select';

/**
 * @typedef {{
 *  details: import('./details').AuditModelUIDetailsReducer,
 *  modal: import('./modal').AuditModelUIModalReducer,
 *  select: import('./select').AuditModelUISelectReducer,
 *  dashboard: import('./dashboard').AuditModelDashboardUIReducer,
 * }} AuditModelUIReducer
 */

export default combineReducers({
  details,
  modal,
  select,
  dashboard,
});
